import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import language from "../../../language";
import CircularProgress from '@mui/material/CircularProgress';
import Grid from "@mui/material/Grid";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import TextField from "@mui/material/TextField";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import axios from "axios";
import Swal from "sweetalert2";
import { SERVER_URL } from "../../../ServerUrl";

const ApplyCouponUser = ({
    couponCode,
    setCouponCode,
    appliedCouponCodes,
    setAppliedCouponCodes,
    bookingDetail,
    setBookingDetail,
    couponResponse,
    setCouponResponse,
    loggedUser,
    isPackage,
}) => {

    let languageSelectedEnglish =
        sessionStorage.getItem("language") === "english" ||
            !sessionStorage.getItem("language")
            ? true
            : false;

    const handleCouponChange = (e) => {
        setCouponCode(e.target.value);
    };


    const handleApplyCoupon = async (e) => {
        e.preventDefault();

        if (!couponCode || couponCode.trim() === "") {
            return Swal.fire({
                icon: "warning",
                title: "Coupon Code Required",
                text: "Please enter a coupon code before applying.",
            });
        }

        if (appliedCouponCodes.includes(couponCode)) {
            return Swal.fire({
                icon: "warning",
                title: "Coupon Already Applied",
                text: "You have already applied this coupon.",
            });
        }

        try {
            let requestBody = {
                couponCode,
                tripType: bookingDetail?.type,
                trip1Id: bookingDetail.tripDetails?.[0]?.tripId,
                trip2Id: bookingDetail.tripDetails?.[1]?.tripId,
            };

            // Agar booking package hai
            if (isPackage) {
                requestBody = {
                    couponCode,
                    isPackage: true,
                    packageId: bookingDetail?.packageId,
                };
            }

            const result = await axios.post(`${SERVER_URL}/admin/check-coupon`, requestBody);
            const data = result.data;
            const discountPercentage = parseFloat(data.discountPercentage);

            // Cashback wale coupons login ke bina allowed nahi
            if (data.couponType === "cashBack" && !loggedUser) {
                return Swal.fire({
                    icon: "info",
                    title: "Cashback Not Allowed",
                    text: "Please log in to apply this coupon",
                });
            }

            if (isPackage) {
                // Package ke liye direct calculation
                const original = bookingDetail.tripDetails?.[0]?.originalPrice || 0;
                const amount = parseFloat(((original * discountPercentage) / 100).toFixed(2));
                console.log(original, amount, "originalamount");

                const updatedCoupons = [
                    ...(bookingDetail.tripDetails?.[0]?.appliedCoupons || []),
                    {
                        code: couponCode,
                        couponType: data.couponType,
                        percentage: discountPercentage,
                        amount,
                    }
                ];

                const totalCouponDiscount = updatedCoupons.reduce((acc, item) => acc + item.amount, 0);
                const cashbackDiscount = updatedCoupons
                    .filter(item => item.couponType === "cashBack")
                    .reduce((acc, item) => acc + item.amount, 0);

                const priceDiscount = updatedCoupons
                    .filter(item => item.couponType === "priceDiscount")
                    .reduce((acc, item) => acc + item.amount, 0);

                setCouponCode('');
                setAppliedCouponCodes(prev => [...prev, couponCode]);
                setBookingDetail(prev => {
                    const updatedTrip = {
                        ...prev.tripDetails[0],
                        price: data.couponType === "priceDiscount"
                            ? parseFloat((original - priceDiscount).toFixed(2))
                            : prev.tripDetails[0].price,
                        appliedCoupons: updatedCoupons,
                        totalCouponDiscount: parseFloat(totalCouponDiscount.toFixed(2)),
                        cashbackDiscount: parseFloat(cashbackDiscount.toFixed(2)),
                        priceDiscount: parseFloat(priceDiscount.toFixed(2)),
                    };

                    return {
                        ...prev,
                        tripDetails: [updatedTrip],
                        totalPaidAmount: updatedTrip.price,
                        totalCashbackDiscount: parseFloat(cashbackDiscount.toFixed(2)),
                        totalPriceDiscount: parseFloat(priceDiscount.toFixed(2)),
                    };
                });

                setCouponResponse({
                    discount1: totalCouponDiscount,
                    discount2: 0,
                    couponType: data.couponType,
                    message: data.message,
                    totalDiscount: parseFloat(totalCouponDiscount.toFixed(2)),
                });

                Swal.fire({
                    title: "Success",
                    icon: "success",
                    text: result?.data?.message,
                });
                return;
            }


            // Trips ke liye same purani logic
            const updatedTripDetails = bookingDetail.tripDetails.map((trip, i) => {
                const isFirst = i === 0;
                const isSecond = i === 1;
                const isApplicable = (isFirst && data.isValidFor1st) || (isSecond && data.isValidFor2nd);

                if (!isApplicable) return trip;

                const original = trip.originalPrice;
                const amount = parseFloat(((original * discountPercentage) / 100).toFixed(2));

                const updatedCoupons = [
                    ...(trip.appliedCoupons || []),
                    {
                        code: couponCode,
                        couponType: data.couponType,
                        percentage: discountPercentage,
                        amount,
                    }
                ];

                const totalCouponDiscount = updatedCoupons.reduce((acc, item) => acc + item.amount, 0);
                const cashbackDiscount = updatedCoupons
                    .filter(item => item.couponType === "cashBack")
                    .reduce((acc, item) => acc + item.amount, 0);

                const priceDiscount = updatedCoupons
                    .filter(item => item.couponType === "priceDiscount")
                    .reduce((acc, item) => acc + item.amount, 0);

                return {
                    ...trip,
                    price: data.couponType === "priceDiscount"
                        ? parseFloat((original - priceDiscount).toFixed(2))
                        : trip.price,
                    appliedCoupons: updatedCoupons,
                    totalCouponDiscount: parseFloat(totalCouponDiscount.toFixed(2)),
                    cashbackDiscount: parseFloat(cashbackDiscount.toFixed(2)),
                    priceDiscount: parseFloat(priceDiscount.toFixed(2)),
                };
            });

            const newTotal = updatedTripDetails.reduce((acc, trip) => acc + trip.price, 0);
            const totalCashback = updatedTripDetails.reduce((acc, trip) => acc + (trip.cashbackDiscount || 0), 0);
            const totalPriceDiscount = updatedTripDetails.reduce((acc, trip) => acc + (trip.priceDiscount || 0), 0);
            const discount1 = updatedTripDetails[0]?.totalCouponDiscount || 0;
            const discount2 = updatedTripDetails[1]?.totalCouponDiscount || 0;

            setAppliedCouponCodes(prev => [...prev, couponCode]);
            setCouponCode('');
            setBookingDetail(prev => ({
                ...prev,
                tripDetails: updatedTripDetails,
                totalPaidAmount: parseFloat(newTotal.toFixed(2)),
                totalCashbackDiscount: parseFloat(totalCashback.toFixed(2)),
                totalPriceDiscount: parseFloat(totalPriceDiscount.toFixed(2)),
            }));

            setCouponResponse({
                discount1,
                discount2,
                couponType: data.couponType,
                message: data.message,
                totalDiscount: parseFloat((discount1 + discount2).toFixed(2)),
            });

            Swal.fire({
                title: "Success",
                icon: "success",
                text: result?.data?.message,
            });

        } catch (err) {
            Swal.fire({
                title: "Error",
                icon: "error",
                text: err?.response?.data?.message || "Something went wrong",
            });
        }
    };



    return (
        <div>
            <Grid
                item
                xs={12}
                sx={{ margin: "20px 0" }}
                justifyContent="space-between"
                display="flex"
            >
                <div style={{ display: "flex", alignItems: "center", alignSelf: "center" }}>
                    {/* <input type="checkbox" name="promo" /> */}

                    <strong>
                        {languageSelectedEnglish
                            ? "I have a discount code"
                            : language.iHaveDiscountCode}
                    </strong>
                </div>
                <Grid
                    item
                    className="couponCodeOuter"
                >
                    <input
                        type="text"
                        className="promo-discount"
                        placeholder={
                            languageSelectedEnglish
                                ? "Enter Coupon Code"
                                : language.enterCouponCode
                        }
                        value={couponCode}
                        onChange={handleCouponChange}
                    />
                    <button
                        className="applyCoupnBtn"
                        onClick={handleApplyCoupon}
                    >
                        {languageSelectedEnglish
                            ? "Apply"
                            : ''}
                    </button>
                </Grid>
            </Grid>
        </div>
    )
}

export default ApplyCouponUser
